import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Indexes from './pages/Indexes';
import Reports from './pages/Reports';
import AutoTrading from './pages/AutoTrading';
import ConnectedUserAccounts from './pages/ConnectedUserAccounts';
import UserAccountDetail from './pages/UserAccountDetail';
import SocialSentiment from './pages/SocialSentiment';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { checkAuthVersion, refreshUserPermissions, initSessionTracking } from './services/api';

function App() {
  // Check session validity, auth version, and refresh permissions on app load
  useEffect(() => {
    // First check if session is valid (not expired, tab wasn't closed)
    // This will logout and redirect if session is invalid
    const sessionValid = initSessionTracking();

    if (sessionValid) {
      // Only check auth version and refresh if session is valid
      checkAuthVersion();
      refreshUserPermissions();
    }
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Routes with page-based access control */}
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPage="dashboard">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute requiredPage="dashboard">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <ProtectedRoute requiredPage="reports">
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/:viewMode"
        element={
          <ProtectedRoute requiredPage="reports">
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute requiredPage="settings">
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/social-sentiment"
        element={
          <ProtectedRoute requiredPage="social-sentiment">
            <SocialSentiment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/indexes"
        element={
          <ProtectedRoute requiredPage="indexes">
            <Indexes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/auto-trading"
        element={
          <ProtectedRoute requiredPage="auto-trading">
            <AutoTrading />
          </ProtectedRoute>
        }
      />
      <Route
        path="/connected-user-accounts"
        element={
          <ProtectedRoute requiredPage="auto-trading">
            <ConnectedUserAccounts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/connected-user-accounts/:id"
        element={
          <ProtectedRoute requiredPage="auto-trading">
            <UserAccountDetail />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;